import script from "./ControlCustomerPageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlCustomerPageTab.vue?vue&type=script&setup=true&lang=ts"

import "./ControlCustomerPageTab.vue?vue&type=style&index=0&id=75029ee3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75029ee3"]])

export default __exports__